import { find } from 'lodash';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Rules } from '@/comp';
import { useStores } from '@/hooks/use-stores';

const RulePage = observer(() => {
  const { ruleType, alertRuleId, alertRecordId } = useParams();
  const { stationStore, rulesStore, alertStore } = useStores();
  const [rules, setRules] = useState([]);
  const [alertRecord, setAlertRecord] = useState();

  useEffect(() => {
    if (!alertRuleId || !alertRecordId) return;
    if (!stationStore.currentStation.id) return;

    async function fetchRule() {
      const newRule = await rulesStore.getById(alertRuleId, ruleType);
      setRules(newRule ? [newRule] : []);
    }

    async function fetchAlertRecord() {
      const alertRecord = alertStore.alertRecordById(alertRecordId);
      setAlertRecord(alertRecord);
    }

    const newRule = find(rulesStore.rules, { alertRuleId });
    newRule ? setRules([newRule]) : fetchRule();

    const alertRecord = alertStore.alertRecordById(alertRecordId);
    alertRecord ? setAlertRecord(alertRecord) : fetchAlertRecord();
  }, [stationStore.currentStation.id, alertRuleId, alertRecordId]);

  return <Rules rules={rules} isSingleMode alertRecord={alertRecord} />;
});

export default RulePage;
